import React, { useState, useContext, useEffect } from "react";
import { Box, } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import SlidingPopup from "../SlidingPopup";
import CommunicationTab from "./CommunicationTab";
import ChecklistTab from "./Checklist/ChecklistTab";
import "./Widget.css";
import HistoryTab from "./History/HistoryTab";
import { PqCommunicationContext } from "../../store/pqCommunication-context";
import { getOrgId, getOrgType } from "../../utils/Token";
import { useLocation } from 'react-router-dom';
import fvAxios from "../../utils/fvAxios";
import BaseURL from "../../utils/base-uri.json";
import { toast } from "react-toastify";
import Button from "../../toolkit/ButtonV1";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';


function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 0 }}>{children}</Box>}
    </div>
  );
}

export default function WidgetDrawer({ widgedVisible, onChangeVisibility }) {
  const { globalPqDetails, setGlobalPqDetails } = useContext(
    PqCommunicationContext
  );
  const urlSearchParams = new URLSearchParams(window.location.search);
  const widgetHistoryTab = urlSearchParams.get('widgetHistoryTab');
  const params = new URLSearchParams(window.location.search);


  const location = useLocation();
  const currentPath = location.search;

  const myString = currentPath
  const stringLength = myString.length;
  const [tabValue, setValue] = useState(myString.charAt(stringLength - 1) == 4 ? 2 : 0);
  const [showSlidingPopup, setShowSlidingPopup] = useState(widgedVisible);
  const [pqId, setPqId] = useState(globalPqDetails.pqId);

  function closeSlidingPopup() {
    setShowSlidingPopup(false);
    onChangeVisibility(false);
  }

  const queryParams = new URLSearchParams(location.search);

  const pqId1 = queryParams.get('pqid');


  if (widgetHistoryTab && tabValue !== 2) {
    setValue(2);

    setTimeout(() => {
      urlSearchParams.delete('widgetHistoryTab');
      const newUrl = `${window.location.pathname}${urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : ''}`;
      window.history.pushState(null, '', newUrl);
    }, 200);
  }

  // useEffect(() => {
  //   setTimeout(() => {

  //     if (widgetHistoryTabnav==2) {
  //       setValue(2)
  //     }
  //   }, 1000);
  // }, [widgetHistoryTabnav]);
  const handleTabChange = async (event, newValue) => {
    setValue(newValue);
  };

  const onSelectCommunicationHandler = (pqId) => {
    setPqId(pqId);
  };

  let isDisabled = pqId === 0 ? true : false;
  const handleOpenNewTab = () => {
    const params = new URLSearchParams({
      pqId: pqId,
      onSelectCommunication: encodeURIComponent(onSelectCommunicationHandler.toString()),
    }).toString();

    window.open(`/content?${params}`, '_blank');
  };


  return (
    <>
      <SlidingPopup
        className="widget-popup"
        title={"Messages"}
        anchor={"right"}
        open={showSlidingPopup}
        closeSlidingPopup={closeSlidingPopup}
      >

        <Box sx={{ width: "100%", bgcolor: "background.paper", height: "20px" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            centered
            className={getOrgType() !== "Admin" ? "custom-tab vendor-view" : "custom-tab"}
          >
            <Tab label="Communication" value={0} />
            {
              getOrgType() === "Admin" && <Tab label="Checklist" value={1} disabled={isDisabled} />
            }
            <Tab label="History" value={2} />
          </Tabs>
          <hr className="mb-0" />
          <TabPanel value={tabValue} index={0}>
            <CommunicationTab
              onSelectCommunication={onSelectCommunicationHandler}
            />
          </TabPanel>
          {
            getOrgType() === "Admin" &&
            <TabPanel value={tabValue} index={1}>
{/* 
              <Box px={2}>

                <Box className="p-3 border-1 bg-white w-100">
                  <Button
                    disabled={false}
                    role="primary"
                    size="small"
                    className={`py-4 w-100`}
                    hidden={!pqId1}
                    onClick={handleOpenNewTab}
                    label={
                      "Open in a New Tab"
                    }
                  ></Button>
                </Box>

              </Box> */}
              <a  className="mx-2" style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "16px",
                                textTransform: "capitalize",
                                textDecoration: "none",
                                color: "rgb(97, 169, 251)",
                                cursor: "pointer",
                                transition: "color 0.3s ease",
                                marginLeft:"auto",padding:"10px",float:"right"
                            }}
                            onMouseEnter={(e) => e.target.style.color = "#0056b3"}
                            // onMouseLeave={(e) => e.target.style.color = "rgb(97, 169, 251)"}  hidden={!pqId1}
                            hidden={true}
                    onClick={handleOpenNewTab}> <OpenInNewIcon className="mx-2"/> Open in a New Tab</a>
              <ChecklistTab pqId={pqId} />
            </TabPanel>
          }
          <TabPanel value={tabValue} index={2}>
            <HistoryTab pqId={pqId} onSelectCommunication={onSelectCommunicationHandler} />
          </TabPanel>
        </Box>
      </SlidingPopup>

    </>
  );
}